<script lang="ts" setup>
import { PropType } from 'vue'
import { Reference } from '../../typings'

// message：接受消息对象，展示消息内容和头像，并且根据角色调整消息位置。
const props = defineProps({
  reference: { type: Object as PropType<Reference>, required: true },
  index: { type:Number  ,required: true},
})


const openInNewTab = (event: MouseEvent) =>
{
    event.preventDefault(); // 阻止默认的 a 标签行为
    window.open(props.reference.url, '_blank'); // 在新窗口/标签页打开链接
}
</script>

<template>
  <div class="reference-item">
    <span v-if="0 == index" class="referenceTitle">
        {{ $t("messageRow.reference") }}
    </span>
    <div class="referenceWrapper">
    <div class="indexWrapper">
        {{(index+1) + "."}}
    </div>
    <div class="urlWrapper">
        <a class="url" :href="reference.url" @click="openInNewTab">{{reference.description}}</a>
    </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/style/_handle.scss";

.reference-item
{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .referenceTitle
    {
      @include font_color("reference-title-font-color");
      margin-bottom: 5px;
    }

    .referenceWrapper{
        display: flex;
        justify-content: flex-start;

        .indexWrapper
        {
            @include font_color("reference-title-font-color");
        }
        .urlWrapper
        {
            margin-left: 10px;
            .url
            {
                @include font_color("reference-font-color");
            }
        }
    }

}

</style>
